import { render, staticRenderFns } from "./BoxLineObject.vue?vue&type=template&id=027b8998&scoped=true&"
import script from "./BoxLineObject.vue?vue&type=script&lang=ts&"
export * from "./BoxLineObject.vue?vue&type=script&lang=ts&"
import style0 from "./BoxLineObject.vue?vue&type=style&index=0&id=027b8998&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "027b8998",
  null
  
)

export default component.exports